import { axiosInstance } from '@configs/axios/axiosInstance';

import type { NationalityDto } from './fetchNationalities.types';

export async function fetchNationalities(): Promise<NationalityDto[]> {
  const { data } = await axiosInstance.get<NationalityDto[]>('/nationalities');
  return data;
}
